<div><canvas baseChart
        [type]="'line'"
        [datasets]="lineChartDatasets"
        [labels]="lineChartLabels"
        [options]="lineChartOptions"></canvas></div>
